module.exports = __webpack_public_path__ + "images/imageIllustration.52b0f6ee.png";